import { combineReducers } from 'redux';

import { tabsReducer } from './Tabs/reducer';
import { tripFieldsReducer } from './FillTrip/reducer';
import { headerReducer } from './Header/reducer';
import { verifyPhoneReducer } from './VerifyPhoneBtn/reducer';
import { scanerReducer } from './ScanerBtn/reducer';
import { commonTripReducer } from './CommonTrip/reducer';
import { weightScalesReducer } from './WeightBtn/reducer';
import { logoutReducer } from './LogoutBtn/reducer';
import { bookingModalReducer } from './BookingModal/reducer';

export const commonReducer = combineReducers({
  tabsReducer,
  tripFieldsReducer,
  headerReducer,
  verifyPhoneReducer,
  scanerReducer,
  commonTripReducer,
  weightScalesReducer,
  logoutReducer,
  bookingModalReducer,
});

export type commonState = ReturnType<typeof commonReducer>;
